export default {
    borderContainer: {
        borderBottom: "0.5px solid #E8E6E6",
    },
}